import { routes as app } from '../app'
import auth from '../domain/auth/services/auth'

const root = [
  {path: '/', redirect: '/dashboard'},
  {
    name: 'logout',
    path: '/logout',
    beforeEnter (to, from, next) {
      auth.logout(() => {
        next('/auth')
      })
    }
  }
]

export default [...root, ...app]



// WEBPACK FOOTER //
// ./src/router/routes.js